import { receiptPdfFileOf } from './rides.js';
export class RideSupportApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /**
     * Search rides. `market` (`cc:slug`) is required unless `q` is a ride id. D413 (W5S-09 b): a POST whose BODY carries the
     * query — a phone never travels in a URL — and a phone search spends the operator's D384 lookup budget (one per agent
     * across markets): beyond it the answer is 429 `SUPPORT_SUBJECT_LOOKUP_RATE_LIMITED` with `retryAfterSeconds`.
     */
    search(q, opts = {}) {
        const body = {
            q,
            ...(opts.market !== undefined && opts.market !== '' ? { market: opts.market } : {}),
            ...(opts.limit !== undefined ? { limit: opts.limit } : {}),
            ...(opts.role !== undefined ? { role: opts.role } : {}),
            ...(opts.cursor !== undefined && opts.cursor !== '' ? { cursor: opts.cursor } : {}),
        };
        return this.client.request({ method: 'POST', path: '/v1/ops/ride-support/rides/search', body, auth: true });
    }
    /** The support view of one ride. */
    detail(rideId) {
        return this.client.request({ method: 'GET', path: `/v1/ops/ride-support/rides/${encodeURIComponent(rideId)}`, auth: true });
    }
    /**
     * The ride's receipt as a one-page PDF (`GET /v1/ops/ride-support/rides/:rideId/receipt.pdf`, word `ride:view` at the ride's market): the same document the rider
     * downloads. The passenger's name, phone and national id are on it only with `rider:view`. 409 `RIDE_NOT_COMPLETED` before the ride is done.
     */
    async receiptPdf(rideId) {
        const res = await this.client.request({ method: 'GET', path: `/v1/ops/ride-support/rides/${encodeURIComponent(rideId)}/receipt.pdf`, auth: true, expect: 'bytes', timeoutMs: 60_000 });
        return res.ok ? { ok: true, value: receiptPdfFileOf(res.value) } : res;
    }
    /**
     * D438 (finding A-03): record the cash a driver handed in for a completed cash ride (`POST /v1/payments/cash`, word
     * `payment:settle`): the driver's commission becomes his receivable, under the ride's own ledger transaction. The amount
     * is bounded by what the ride charged (`CASH_AMOUNT_ABOVE_DUE`), in its currency, for its assigned driver.
     */
    settleCash(input) {
        return this.client.request({
            method: 'POST',
            path: '/v1/payments/cash',
            body: { rideId: input.rideId, driverId: input.driverId, amountMinor: input.amount.amountMinor, currency: input.amount.currency },
            auth: true,
        });
    }
}
//# sourceMappingURL=ride-support.js.map